(function () {
  var STORAGE_KEY = 'be_wishlist_v1';

  function readItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    syncUi();
    document.dispatchEvent(new CustomEvent('be:wishlist-updated', { detail: { count: items.length } }));
  }

  function isWishlisted(productId) {
    var id = String(productId);
    return readItems().some(function (item) {
      return String(item.id) === id;
    });
  }

  function toggleFromButton(button) {
    var product = {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      variantId: button.dataset.variantId || '',
    };

    if (!product.id) return;

    var items = readItems();
    var index = items.findIndex(function (item) {
      return String(item.id) === String(product.id);
    });

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift(product);
    }

    writeItems(items);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateCartBadge(count) {
    document.querySelectorAll('[data-be-cart-count]').forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count > 9 ? '9+' : String(count);
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    });
  }

  function resolveVariantId(item) {
    if (item.variantId) {
      return Promise.resolve(String(item.variantId));
    }

    if (!item.handle) {
      return Promise.resolve(null);
    }

    return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('product fetch failed');
        return response.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (v) {
          return v.available;
        });
        if (!variant) return null;

        var items = readItems();
        var idx = items.findIndex(function (entry) {
          return String(entry.id) === String(item.id);
        });
        if (idx >= 0) {
          items[idx].variantId = String(variant.id);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        }

        return String(variant.id);
      })
      .catch(function () {
        return null;
      });
  }

  function setBuyButtonsLoading(loading, message) {
    document.querySelectorAll('[data-be-wishlist-buy-all], [data-be-wishlist-buy-one]').forEach(function (button) {
      button.disabled = loading;
      if (loading) {
        button.dataset.beOriginalText = button.textContent;
        if (button.hasAttribute('data-be-wishlist-buy-all')) {
          button.textContent = message || 'Ekleniyor...';
        }
      } else if (button.dataset.beOriginalText) {
        button.textContent = button.dataset.beOriginalText;
        delete button.dataset.beOriginalText;
      }
    });
  }

  function buyWishlistItems(items, checkout) {
    if (!items.length) return Promise.resolve();

    setBuyButtonsLoading(true, 'Ekleniyor...');

    return Promise.all(
      items.map(function (item) {
        return resolveVariantId(item).then(function (variantId) {
          return variantId ? { id: Number(variantId), quantity: 1 } : null;
        });
      })
    )
      .then(function (resolved) {
        var cartItems = resolved.filter(Boolean);
        if (!cartItems.length) {
          throw new Error('no variants');
        }

        return fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: cartItems }),
        }).then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        });
      })
      .then(function () {
        return fetch('/cart.js').then(function (response) {
          return response.json();
        });
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        if (checkout) {
          window.location.href = '/checkout';
          return;
        }
        window.location.href = window.routes?.cart_url || '/cart';
      })
      .catch(function () {
        alert('Ürünler sepete eklenemedi. Lütfen beden/renk seçerek tekrar deneyin.');
      })
      .finally(function () {
        setBuyButtonsLoading(false);
      });
  }

  function buildItemHtml(item, compact) {
    var image = item.image
      ? '<img src="' + item.image + '" alt="" class="be-wishlist-page__img" loading="lazy">'
      : '<span class="be-wishlist-page__img be-wishlist-page__img--empty"></span>';

    if (compact) {
      return (
        '<article class="be-wishlist-drawer__item">' +
        '<a class="be-wishlist-drawer__media" href="' +
        item.url +
        '">' +
        image +
        '</a>' +
        '<div class="be-wishlist-drawer__info">' +
        '<a class="be-wishlist-drawer__title" href="' +
        item.url +
        '">' +
        escapeHtml(item.title) +
        '</a>' +
        (item.price ? '<p class="be-wishlist-drawer__price">' + escapeHtml(item.price) + '</p>' : '') +
        '<button type="button" class="be-wishlist-drawer__buy-one" data-be-wishlist-buy-one="' +
        item.id +
        '">Satın Al</button>' +
        '</div>' +
        '<button type="button" class="be-wishlist-drawer__remove" data-be-wishlist-remove="' +
        item.id +
        '" aria-label="Kaldır">×</button>' +
        '</article>'
      );
    }

    return (
      '<article class="be-wishlist-page__item">' +
      '<a class="be-wishlist-page__media" href="' +
      item.url +
      '">' +
      image +
      '</a>' +
      '<div class="be-wishlist-page__body">' +
      '<a class="be-wishlist-page__title" href="' +
      item.url +
      '">' +
      escapeHtml(item.title) +
      '</a>' +
      (item.price ? '<p class="be-wishlist-page__price">' + escapeHtml(item.price) + '</p>' : '') +
      '<div class="be-wishlist-page__actions">' +
      '<button type="button" class="be-wishlist-page__buy" data-be-wishlist-buy-one="' +
      item.id +
      '">Satın Al</button>' +
      '<a class="be-wishlist-page__view" href="' +
      item.url +
      '">Ürüne Git</a>' +
      '<button type="button" class="be-wishlist-page__remove" data-be-wishlist-remove="' +
      item.id +
      '">Kaldır</button>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function toggleFooters(itemsLength) {
    document.querySelectorAll('[data-be-wishlist-footer], [data-be-wishlist-page-footer]').forEach(function (footer) {
      footer.hidden = itemsLength === 0;
    });
  }

  function renderContainer(root, listSelector, emptySelector, countSelector, compact) {
    if (!root) return;

    var list = root.querySelector(listSelector);
    var empty = root.querySelector(emptySelector);
    var countEl = countSelector ? root.querySelector(countSelector) : null;
    var items = readItems();

    if (countEl) {
      countEl.textContent = window.beFormatWishlistCount
        ? window.beFormatWishlistCount(items.length)
        : items.length + ' ürün';
    }

    if (!list || !empty) return;

    if (!items.length) {
      list.innerHTML = '';
      list.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    list.hidden = false;
    list.innerHTML = items.map(function (item) {
      return buildItemHtml(item, compact);
    }).join('');
  }

  function updateBadges() {
    var count = readItems().length;
    document.querySelectorAll('[data-be-wishlist-count]').forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count > 9 ? '9+' : String(count);
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-be-wishlist-toggle]').forEach(function (button) {
      var active = isWishlisted(button.dataset.productId);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        active
          ? (window.beStrings && window.beStrings.wishlistRemove) || 'Remove from wishlist'
          : (window.beStrings && window.beStrings.wishlistAdd) || 'Add to wishlist'
      );
    });
  }

  function syncProductPageVariant() {
    var wishlistBtn = document.querySelector('.be-wishlist-btn--page[data-be-wishlist-toggle]');
    var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!wishlistBtn || !variantInput || !variantInput.value) return;
    wishlistBtn.dataset.variantId = variantInput.value;
  }

  function renderWishlistViews() {
    var items = readItems();

    renderContainer(
      document.querySelector('[data-be-wishlist-page]'),
      '[data-be-wishlist-list]',
      '[data-be-wishlist-empty]',
      '[data-be-wishlist-page-count]',
      false
    );

    document.querySelectorAll('[data-be-wishlist-drawer-root]').forEach(function (root) {
      renderContainer(root, '[data-be-wishlist-drawer-list]', '[data-be-wishlist-drawer-empty]', null, true);
    });

    document.querySelectorAll('[data-be-wishlist-drawer-count]').forEach(function (el) {
      el.textContent = window.beFormatWishlistCount
        ? window.beFormatWishlistCount(items.length)
        : items.length + ' ürün';
    });

    toggleFooters(items.length);
  }

  function syncUi() {
    updateBadges();
    syncButtons();
    syncProductPageVariant();
    renderWishlistViews();
  }

  function closeMenuDrawer() {
    document.querySelectorAll('.be-store__drawer.is-open').forEach(function (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      var burger = document.querySelector('.be-store__burger');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    });
  }

  function closeWishlistDrawer() {
    document.querySelectorAll('[data-be-wishlist-drawer].is-open').forEach(function (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.querySelectorAll('[data-be-wishlist-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.body.style.overflow = '';
    });
  }

  function openWishlistDrawer() {
    closeMenuDrawer();
    var drawer = document.querySelector('[data-be-wishlist-drawer]');
    if (!drawer) return;
    renderWishlistViews();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-be-wishlist-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[name="id"]')) {
      syncProductPageVariant();
    }
  });

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-be-wishlist-open]');
    if (openBtn) {
      event.preventDefault();
      openWishlistDrawer();
      return;
    }

    if (event.target.closest('[data-be-wishlist-close]')) {
      event.preventDefault();
      closeWishlistDrawer();
      return;
    }

    var buyAllBtn = event.target.closest('[data-be-wishlist-buy-all]');
    if (buyAllBtn) {
      event.preventDefault();
      var checkout = buyAllBtn.getAttribute('data-checkout') === 'true';
      buyWishlistItems(readItems(), checkout);
      return;
    }

    var buyOneBtn = event.target.closest('[data-be-wishlist-buy-one]');
    if (buyOneBtn) {
      event.preventDefault();
      var productId = buyOneBtn.getAttribute('data-be-wishlist-buy-one');
      var item = readItems().find(function (entry) {
        return String(entry.id) === String(productId);
      });
      if (item) {
        buyWishlistItems([item], true);
      }
      return;
    }

    var toggle = event.target.closest('[data-be-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleFromButton(toggle);
      return;
    }

    var removeBtn = event.target.closest('[data-be-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      var removeId = removeBtn.getAttribute('data-be-wishlist-remove');
      var items = readItems().filter(function (item) {
        return String(item.id) !== String(removeId);
      });
      writeItems(items);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncUi);
  } else {
    syncUi();
  }
})();
